<template>
  <section class="lectors py-12 my-16 px-md-10 px-4">
    <div class="lectors__title d-flex">
      <h2 class="mr-3">{{ lectorsData.title }}</h2>
      <h2 class="lectors__title-year">2025</h2>
    </div>
    <speaker-slider :data="lectors" />
    <v-divider class="my-10 lectorDivider" />
    <speaker-slider :data="musicLectors" />
  </section>
</template>

<script>
import SpeakerSlider from "@/components/SpeakerSlider.vue";

export default {
  name: "Lectors",
  components: {
    SpeakerSlider
  },
  computed: {
    lectorsData() {
      return this.$t("lectors");
    },
    lectors() {
      const speakers = this.$t("lectors").lectors ?? [];
      return speakers.filter(speakerItem => !speakerItem?.isOther);
    },
    musicLectors() {
      const speakers = this.$t("lectors").lectors ?? [];
      return speakers.filter(speakerItem => speakerItem?.isOther);
    }
  }
  // created() {
  //   this.$store.dispatch("loadLectors");
  //
};
</script>

<style lang="sass" scoped>
.lectors
  min-height: 100vh
  &__title
    &-year
      opacity: .2
      font-family: 'Inter', sans-serif
      font-weight: 300

.lectorDivider
  border-width: 1px
</style>
